import Card from "@mui/material/Card";
import SoftBox from "components/SoftBox";
import DashboardLayout from "cxfcomponents/LayoutContainers/DashboardLayout";
import DashboardNavbar from "cxfcomponents/Navbars/DashboardNavbar";
import { LibraryConnectors } from "../library/connectors";

const Connector = () => {
  return (
    <>
      <div style={{
        padding: "8px",
        position: "sticky",
        top: 0,
        zIndex: 1000,
        backgroundColor: "var(--main-bg-color)"
      }}>
        <DashboardNavbar />
      </div>
      <DashboardLayout sx={{ padding: "8px 0 0 0" }}>
        <SoftBox sx={{ mt: -4.2, mb: 0.5 }}>
          <Card sx={{
            padding: "8px 0 0 0",
            mb: -0.4,
            background: "none !important",
            boxShadow: "none"
          }}>
            <LibraryConnectors />
          </Card>
        </SoftBox>
      </DashboardLayout>
    </>
  );
};

export default Connector;
